import Vue from 'vue';
import Toast from '@/components/ux/Toast.vue';

const Toaster = Vue.extend(Toast);

export default function showToast(options) {
    /* eslint-disable no-new */
    const instance = new Toaster({ data: options });
    instance.$mount();
    document.body.appendChild(instance.$el);

    return instance;
}